<script type="text/javascript">

    import { http } from '../../http';
    import axios from 'axios';
    import debounce from 'lodash/debounce';

    export default {

        data: function(){

            return {
                search_data : [],
                search_data_loaded : false,
                search_loading : false,
                search_focus: false,
                search_term: '',
                timeout : false,
                active_request_source: false,
                icons: {
                    client: "zmdi-accounts",
                    invoice: "zmdi-file-text",
                    creditnote: "zmdi-file-text",
                    event: "zmdi-calendar",
                    booking: "zmdi-calendar-alt",
                }
            }
        },
        props: {
            searchEndpoint: {
                required: false,
                default: '/app/search',
            },
            open: {
                type: Boolean,
                default: false
            }
        },
        mounted: function(){
            this.$nextTick(function() {
                // Connect the nord command menu input to the search
                const menu = this.$refs.commandMenu;
                menu.addEventListener("input", (e) => {
                    const input = menu.shadowRoot?.querySelector("input");
                    if (input) {
                        this.search_term = input.value;
                    }
                });

                menu.addEventListener('open', this.showTypeToSearchPromt);
                menu.addEventListener('close', this.hideSearch);
            });
        },

        computed: {
            showClientId() {
                return this.$store.state.features?.show_client_id ?? false;
            },
        },

        watch: {
            search_term : function(val, oldVal){
                if(val !== oldVal && val.length > 0){
                    this.showLoadingState();
                    this.getSearchData();
                } else if (val.length === 0) {
                    this.showTypeToSearchPromt();
                }
            },
            open(val) {
                if (val) {
                    this.showTypeToSearchPromt();
                }
            }
        },

        methods: {
            getSearchData : debounce(function(){
                this.search_loading = true;
                this.search_focus = true;

                if(this.active_request_source){
                    this.active_request_source.cancel('Operation canceled by the user.');
                }

                var CancelToken = axios.CancelToken;
                this.active_request_source = CancelToken.source();

                http.get(this.searchEndpoint, {
                    cancelToken: this.active_request_source.token,
                    params: {
                        search: this.search_term,
                    }
                })
                .then(({ data }) => {
                    this.search_loading = false;
                    this.search_data = data.map((item) => {
                        let title = item.label;

                        if (this.showClientId && item.type === 'client') {
                            title += ` - ${this.trans('clients.id')} ${item.key}`;
                        }

                        return {
                            id: item.type + "-" + item.key,
                            title: title,
                            section: item.type,
                            keywords: this.search_term, // Add search_term to keywords to bypass Nord's internal filtering and show all results fetched from the backend.
                            handler: () => {
                                window.location.href = item.url;
                            },
                        };
                    });
                    this.updateMenuCommands();
                    this.search_data_loaded = true;
                })
                .catch(() => {
                    this.search_loading = false;
                });

            }, 700),

            updateMenuCommands() {
                const menu = this.$refs.commandMenu;

                if (menu) {
                    menu.commands = this.search_data;
                }
            },

            showTypeToSearchPromt() {
                this.search_data = [{
                    id: 'initialState',
                    title: trans('global.search_prompt'),
                    icon: 'interface-ai',
                    keywords:
                    this.search_term
                }];
                this.updateMenuCommands();
            },

            showLoadingState() {
                this.search_data = [{
                    id: 'loadingState',
                    title: trans('clients.select_4'),
                    icon: 'interface-ai',
                    keywords:
                    this.search_term
                }];
                this.updateMenuCommands();
            },

            hideSearch() {
                console.log('Search closed');
                this.$emit('close');
            }
        },
    };
</script>

<template id="search">
    <nord-command-menu ref="commandMenu" :open="open"></nord-command-menu>
</template>

<style lang="scss" scoped>
  @media (max-width: 650px) {
    nord-command-menu {
      --n-command-menu-inline-size: 90vw;
    }
  }
</style>

